import { useMemo } from 'react'
import { IPointsInfo } from '../types'

interface IUsePointsList {
  (list: IPointsInfo['list']): {
    point: number | null
    year: number | null
    value: number
  }[]
}

export const usePointsList: IUsePointsList = (list) => {
  const items = useMemo(() => {
    return list || []
  }, [list])

  const percents = useMemo(() => {
    const values = items.map((el) => {
      return el.examPoints || 0
    })

    const max = Math.max(...values)

    return values.map((num) => {
      return Math.round((num / max) * 100)
    })
  }, [items])

  return useMemo(() => {
    return items
      .map((el, key) => {
        return {
          point: el.examPoints,
          value: percents[key],
          year: el.year,
        }
      })
      .filter((el) => {
        return el.year && el.point
      })
  }, [items, percents])
}
